import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group col-sm-12" }
const _hoisted_8 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "d-flex",
  style: {"column-gap":"3em"}
}
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountWidget = _resolveComponent("AccountWidget")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_SystemAccounts = _resolveComponent("SystemAccounts")!
  const _component_Traders = _resolveComponent("Traders")!
  const _component_Merchants = _resolveComponent("Merchants")!
  const _component_MerchantOperators = _resolveComponent("MerchantOperators")!
  const _component_TraderOperators = _resolveComponent("TraderOperators")!
  const _component_Users = _resolveComponent("Users", true)!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tabs, (value, tab) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: tab,
                          class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                        }, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.selectTab(tab)), ["prevent"]),
                            class: _normalizeClass(["nav-link tab", {'active': _ctx.activeTabName === tab}])
                          }, _toDisplayString(_ctx.helper.trans(`users.tab.${tab}`)), 11, _hoisted_9)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createVNode(_component_LoaderWrapper, {
                  ref: "summaryLoader",
                  class: "h-100"
                }, {
                  default: _withCtx(() => [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary, (account) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_AccountWidget, {
                                  "show-icon": "",
                                  "hide-insurance": "",
                                  account: account
                                }, null, 8, ["account"])
                              ])
                            ]))
                          }), 256))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 512)
              ])
            ]),
            (_ctx.activeTabName === _ctx.Tabs.system)
              ? (_openBlock(), _createBlock(_component_SystemAccounts, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.activeTabName === _ctx.Tabs.traders)
              ? (_openBlock(), _createBlock(_component_Traders, {
                  key: 1,
                  type: "traders"
                }))
              : _createCommentVNode("", true),
            (_ctx.activeTabName === _ctx.Tabs.providers)
              ? (_openBlock(), _createBlock(_component_Traders, {
                  key: 2,
                  type: "providers"
                }))
              : _createCommentVNode("", true),
            (_ctx.activeTabName === _ctx.Tabs.merchants)
              ? (_openBlock(), _createBlock(_component_Merchants, { key: 3 }))
              : _createCommentVNode("", true),
            (_ctx.activeTabName === _ctx.Tabs.merchantOperators)
              ? (_openBlock(), _createBlock(_component_MerchantOperators, { key: 4 }))
              : _createCommentVNode("", true),
            (_ctx.activeTabName === _ctx.Tabs.traderOperators)
              ? (_openBlock(), _createBlock(_component_TraderOperators, { key: 5 }))
              : _createCommentVNode("", true),
            (_ctx.activeTabName === _ctx.Tabs.operators)
              ? (_openBlock(), _createBlock(_component_Users, {
                  key: 6,
                  role: _ctx.UserRole.OPERATOR
                }, null, 8, ["role"]))
              : _createCommentVNode("", true),
            (_ctx.activeTabName === _ctx.Tabs.teamleads)
              ? (_openBlock(), _createBlock(_component_Users, {
                  key: 7,
                  role: _ctx.UserRole.TRADER_TEAM_LEAD
                }, null, 8, ["role"]))
              : _createCommentVNode("", true),
            (_ctx.activeTabName === _ctx.Tabs.referrals)
              ? (_openBlock(), _createBlock(_component_Users, {
                  key: 8,
                  role: _ctx.UserRole.REFERRAL
                }, null, 8, ["role"]))
              : _createCommentVNode("", true),
            (_ctx.activeTabName === _ctx.Tabs.admins)
              ? (_openBlock(), _createBlock(_component_Users, {
                  key: 9,
                  role: _ctx.UserRole.ADMIN
                }, null, 8, ["role"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}